import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { DrakeSharedService } from '../drake-shared.service';
import { messages } from 'app/mock-api/apps/chat/data';
import { HttpClient } from '@angular/common/http';

export interface AutomatedResponse  {
    question: string,
    response : string,
    suggestedActions: { type: string, value: string }[]
    type: string,
}

@Injectable({
    providedIn: 'root',
})

export class ChatService {
    public readonly responses: Observable<AutomatedResponse> = new Observable<AutomatedResponse>();
    private connectionSubject: Subject<boolean> = new Subject<boolean>();
    public latestMessage: string = '';
    private responsesUrl = './assets/images/icons/response.json';
    
    constructor(private drakeSharedService: DrakeSharedService, private http: HttpClient) {
        this.drakeSharedService.messageReceived.subscribe((message: string) => {
            
            this.latestMessage = message;
            const type = 'reply';
            message = message.replace(/```html/g, '');
            message = message.replace(/```/g, '');
            //this.responses.next(message);
            console.log('il messaggio dei messaggi', message);
        });
    }

    public getResponses(): Observable<any> {
   
        return this.http.get(this.responsesUrl);
    }
    
    public async automatedResponse(question: string): Promise<AutomatedResponse> {
        try {
            const data = await this.getResponses().toPromise(); // Trasformiamo l'Observable in Promise

            // Troviamo la risposta che corrisponde alla domanda
            const filteredResponse = data.responses.find((response: any) => response.question === question);
            console.log('Risposta filtrata:', filteredResponse);

            if (filteredResponse) {
                // Creiamo un array con gli oggetti {type, response} relativi agli ID in suggestedActions
                const suggestedActions = filteredResponse.suggestedActions.map((actionId: number) => {
                    return data.responses.find((response: any) => response.id === actionId);
                }).filter((response: any) => response !== undefined);  // Filtra eventuali undefined (se l'ID non esiste)

                // Ora abbiamo un array con gli oggetti {type, response}
                const actionsData = suggestedActions.map((action: any) => ({
                    type: action.type,
                    response: action.question
                }));

                console.log('Azioni suggerite:', actionsData);

                // Restituiamo l'oggetto finale
                return {
                    question: filteredResponse.question,
                    response: filteredResponse.response,
                    suggestedActions: actionsData,
                    type: filteredResponse.type
                };
            } else {
                // Se non troviamo una risposta, restituiamo una risposta di default
                return {
                    question: 'Non ho una risposta per questa domanda.',
                    response: 'Non ho una risposta per questa domanda.',
                    suggestedActions: [],
                    type: null
                };
            }
        } catch (error) {
            console.error('Errore durante la richiesta delle risposte:', error);
            throw error; // Rilanciamo l'errore per gestirlo a livello di chiamata
        }
    }

    

    public submit(question: string): void {
        console.log('submit ahahhaahhahahaahh', question);

        this.drakeSharedService.createWsConnection();

        this.connectionSubject.subscribe((isConnected) => {
            if (isConnected) {
                const questionString = question;

                this.drakeSharedService.ws.client
                    ?.publish(
                        'U00000001/DRAKEBOT/REQUEST',
                        JSON.stringify({
                            message: questionString,
                            token: localStorage.getItem('accessToken'),
                        })
                    )
                    .subscribe((message) => {
                        console.log('Risposta ricevuta:', message);
                    });
            } else {
                console.log('MQTT connection failed or not established yet');
            }
        });

        if (this.drakeSharedService.ws.connectionState) {
            this.connectionSubject.next(true);
        } else {
            this.drakeSharedService.ws.client?.onConnect.subscribe(() => {
                this.drakeSharedService.ws.connectionState = true;
                this.connectionSubject.next(true);
            });
        }
    }
}
